const getters = {
  dataTheme: (state) => state.setting.dataTheme,
  newsContent: (state) => state.setting.newsContent,
  isCollapse: (state) => state.setting.isCollapse,
  screenWidth: (state) => state.setting.screenWidth,
  screenHeight: (state) => state.setting.screenHeight,
  isMobileScreen: (state) => (state.setting.screenWidth < 992),
  showBackTop: (state) => state.setting.settings.backTop === 'true',
  riskStatementMustRead: (state) => state.setting.settings.riskStatementMustRead === 'true',
  settings: (state) => state.setting.settings,
  menus: (state) => state.data.menus,
};
export default getters;
